@if (question?.question_prompt) {
  <div class="notice notice--info">
    <div class="notice__content">
      <svg class="icon">
        <use xlink:href="#info"></use>
      </svg>
      <p>{{question?.question_prompt}}</p>
    </div>
  </div>
}
